import {promiseQueue} from "services/helper";
import Api, {dateToServer} from "services/Api";

/**
 * Mutation Types
 * 
 * @type {Object}
 */
const mutationTypes = {};

/**
 * State.
 * 
 * @type {Object}
 */
const state = {};

/**
 * Getters.
 * 
 * @type {Object}
 */
const getters = {};

/**
 * Actions.
 * 
 * @type {Object}
 */
const actions = {
    /**
     * Dispatches save requests to the correct step.
     */
    save({ commit, rootGetters }, payload) {},
    /**
     * Dispatches loading of a step requests to the correct step.
     */
    load({ commit, dispatch, rootGetters }, step) {},
    /**
     * Dispatches validation of a step.
     */
    validate({ commit, dispatch, rootGetters }, step) {},
    /**
     * Dispatches process requests to the correct step.
     */
    process({ commit, dispatch, rootState }, step) {},
    /**
     * Dispatches reset requests to the correct step.
     */
    reset({ dispatch, rootState }, step) {},
};

/**
 * Mutations
 *
 * @type {Object}
 */
const mutations = {};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/personal/documents.js